export default {
  'reports.title': 'Reports',
  'reports.manageReports.title': 'Manage Reports',
  'reports.manageGroups.title': 'Configure Report Group',
  'reports.tab.groups': 'Groups',
  'reports.tab.favorites': 'Favorites',

  'reports.manageGroups.components.powerBIServerConfigurationId': 'Power BI Server Configuration',
  'reports.manageGroups.components.powerBIReportGroupId': 'PowerBI Report Group Id',
  'reports.manageGroups.components.powerBIReportId': 'PowerBI Report Id',
  'reports.manageGroups.components.menuTitle': 'Menu Title',
  'reports.manageGroups.components.menuTooltip': 'Menu Tooltip',
  'reports.manageGroups.components.textHelp': 'Menu Help Text',
  'reports.manageGroups.components.asLink': 'Show as Link',
  'reports.manageGroups.components.powerBIConnector': 'Power BI Connector',

  'reports.manageReports.components.report-group': 'Report Group',
  'reports.manageReports.components.tagLink': 'Report Classification Tags',
  'reports.manageReports.components.multiplePages': 'Multiple Pages?',
  'reports.manageReports.components.defaultReport': 'Default Report Section',
  'reports.manageReports.components.enableDataFilter': 'Enable Report Data Filter by User?',
  'reports.manageReports.components.reportFilter': 'Enable Report Data Filter by User?',

  'reports.manageReports.components.reportId': 'PowerBI Report Id',
  'reports.manageReports.components.datasetId': 'PowerBI Dataset Id',
  'reports.manageReports.components.defaultReportSection': 'Default Report Section',
  'reports.manageReports.components.isMultipage': 'Multiple Pages?',
  'reports.manageReports.components.isReportDataFilterByUserEnabled':
    'Enable Report Data Filter by User?',
  'reports.manageReports.components.isReportDataFilterByPositionEnabled':
    'Filter Report Data by Position?',
  'reports.platform': 'Platform',

  'reports.manageReports.components.reportDataFilterUserTableName': 'Table Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldName': 'Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldNameInternal':
    'Internal Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterPositionTableName':
    'Table Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldName':
    'Field Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldNameInternal':
    'Internal Field Name for Position Filter',
  'reports.operador.or': 'Or',
  'reports.operador.and': 'And',
  'reports.permissionsFiltersLogicalOperator': 'Logical Operator for Permissions Filters',

  'reports.type.administration': 'Administration',
  'reports.type.process': 'Process',
  'reports.type.request': 'Request',
  'reports.type.generic': 'Generic',
  'reports.type.powerbiconnector': 'Power BI Connector',

  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Mobile',
  'reports.platform.webmobile': 'WebMobile',
};
